import React, { Fragment, Component } from "react";
import { Container, Row, Col, Form, Button, Image } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";

import { Link, withRouter } from "react-router-dom";
import { Header, Banner, Services, GetInTouch, Footer } from "../index";
import { GoogleAutocomplete, checkValidations } from "../helpers";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "react-bootstrap/Alert";

import Axios from "../../Actions/Axios";
import {
  API_URL,
  MOBILE_URL,
  API_VERSION,
  GET_DUMPSTER_SIZES,
  GET_DUMPSTER_MATERIALS,
  GET_AGENTS,
  CHECK_ZIPCODE,
  dropon,
  dropAccess,
  dumpDuration,
  hearUs,
  bestWay,
} from "../../Actions/ApiUrls";
class OrderSubmit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "city",
      dumpsize: [],
      matrialSizes: [],
      hearUs: [],
      citylist: [],
      bestContactList: [],
      dumpsterDurationList: [],
      dropOnList: [],
      dropaccess: [],
      firstname: "",
      lastname: "",
      email: "",
      dumpsterSizeService: "",
      materialType: "",
      phoneNumber: "",
      cityService: "",
      zipCode: "",
      dropDate: "",
      pickDate: "",
      dropOn: "",
      dumpsterDuration: "",
      dropAccess: "",
      bestContact: "",
      hearAboutUs: "",
      companyInfo: "",
      anyOtherInfo: "",
      startLocationAddr: "",
      startLocation: { lat: 0.0, lng: 0.0 },
      status: "pending",
      agentsList: [],
      dumpType: "null",
    };
  }

  componentDidMount() {
    Axios.get(MOBILE_URL + API_VERSION + GET_DUMPSTER_SIZES)
      .then((res) => {
        let data = res.data.data;
        if (data.length > 0) {
          this.setState({ dumpsize: data });
        }
      })
      .catch((err) => {
        console.log("No Dumplster");
      });

    Axios.get(MOBILE_URL + API_VERSION + GET_DUMPSTER_MATERIALS)
      .then((res) => {
        let data = res.data.data;
        if (data.length > 0) {
          this.setState({ matrialSizes: data });
        }
      })
      .catch((err) => {
        console.log("No Sizes");
      });
    Axios.get(API_URL + API_VERSION + GET_AGENTS)
      .then((res) => {
        let data = res.data.data;
        if (data.length > 0) {
          this.setState({ agentsList: data });
        }
      })
      .catch((err) => {
        console.log("No Agents");
      });
  }
  handleChange = (e) => {
    e.preventDefault();

    if (e.target.name === "dropDate") {
      let CurrentDate = new Date();
      CurrentDate.setHours(0, 0, 0, 0);
      let GivenDate = new Date(e.target.value);
      GivenDate.setHours(0, 0, 0, 0);
      if (GivenDate < CurrentDate) {
        this.setState({
          [e.target.name]: "",
          alertVisible: true,
          alertClass: "danger",
          alertMessage: "Drop date Should be Equal or greater than Today date.",
        });
        return false;
      } else {
        this.setState({
          alertVisible: false,
          [e.target.name]: e.target.value,
        });
      }
    } else if (e.target.name === "pickDate") {
      let CurrentDate2 = new Date(this.state.dropDate);
      let GivenDate2 = new Date(e.target.value);
      let days = this.date_diff_indays(CurrentDate2, GivenDate2);
      if (days < 0) {
        this.setState({
          [e.target.name]: "",
          alertVisible: true,
          alertClass: "danger",
          alertMessage: "Pick date Should be Equal or greater than Drop date.",
        });
        return false;
      } else if (days > 28) {
        this.setState({
          [e.target.name]: e.target.value,
          alertVisible: true,
          alertClass: "danger",
          alertMessage:
            "Our Senior manager connect you with special longer term-rates",
        });
        return false;
      } else {
        this.setState({
          alertVisible: false,
          [e.target.name]: e.target.value,
        });
      }
    } else {
      this.setState({
        alertVisible: false,
        [e.target.name]: e.target.value,
      });
    }
  };
  date_diff_indays = (date1, date2) => {
    let dt1 = new Date(date1);
    let dt2 = new Date(date2);
    return Math.floor(
      (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
        Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
        (1000 * 60 * 60 * 24)
    );
  };

  handleDate = (date, key) => {
    console.log(date, 65655655);
    if (key === "dropDate") {
      let CurrentDate = new Date();
      CurrentDate.setHours(0, 0, 0, 0);
      let GivenDate = new Date(date);
      GivenDate.setHours(0, 0, 0, 0);
      if (GivenDate < CurrentDate) {
        this.setState({
          [key]: "",
          alertVisible: true,
          alertClass: "danger",
          alertMessage: "Drop date Should be Equal or greater than Today date.",
        });
        return false;
      } else {
        this.setState({
          alertVisible: false,
          [key]: date,
        });
      }
    } else if (key === "pickDate") {
      let CurrentDate2 = new Date(this.state.dropDate);
      let GivenDate2 = new Date(date);
      let days = this.date_diff_indays(CurrentDate2, GivenDate2);
      if (days < 0) {
        this.setState({
          [key]: "",
          alertVisible: true,
          alertClass: "danger",
          alertMessage: "Pick date Should be Equal or greater than Drop date.",
        });
        return false;
      } else if (days > 28) {
        this.setState({
          [key]: date,
          alertVisible: true,
          alertClass: "danger",
          alertMessage:
            "Our Senior manager connect you with special longer term-rates",
        });
        return false;
      } else {
        this.setState({
          alertVisible: false,
          [key]: date,
        });
      }
    }
  };
  submitDumpster = (e) => {
    e.preventDefault();
    const {
      firstname,
      lastname,
      email,
      dumpsterSizeService,
      materialType,
      phoneNumber,
      phoneNumber2,
      cityService,
      zipCode,
      pincode,
      dropDate,
      dropTime,
      pickDate,
      pickTime,
      dropOn,
      dumpsterDuration,
      dropaccess,
      bestContact,
      hearAboutUs,
      companyInfo,
      companyTitle,
      anyOtherInfo,
      startLocationAddr,
      startLocation,
      dumpType,
      agentsList,
    } = this.state;

    const agentNM = agentsList.find((a) => a._id === dumpType);
    let data = {
      fName: firstname,
      lName: lastname,
      email: email,
      dumpsterSizeService: dumpsterSizeService,
      materialType: materialType,
      phoneNumber: phoneNumber,
      phoneNumber2: phoneNumber2,
      cityService: cityService,
      zipCode: pincode,
      dropDate: dropDate,
      dropTime: dropTime,
      pickTime: pickTime,
      pickDate: pickDate,
      dropOn: dropOn,
      // dumpsterDuration: dumpsterDuration,
      dropAccess: dropaccess,
      bestContact: bestContact,
      hearAboutUs: hearAboutUs,
      companyInfo: companyInfo,
      companyTitle: companyTitle,
      anyOtherInfo: anyOtherInfo,
      startLocationAddr: startLocationAddr,
      endLocationAddr: startLocationAddr,
      startLocation: startLocation,
      endLocation: startLocation,
      status: "pending",
      agentId: dumpType === "null" ? null : dumpType !== "" ? dumpType : null,
      agentName:
        agentNM && agentNM.name
          ? agentNM.name
          : dumpType === "null"
          ? "Customer"
          : "",
    };
    console.log(data, 66666);
    let valid = checkValidations(data);

    if (pickDate === "" || dropDate === "") {
      this.setState({
        alertVisible: true,
        alertClass: "danger",
        alertMessage: "Drop Off, Pick off Dates are required",
      });
      return;
    }

    data = valid.data;
    data.pickDate = moment(pickDate).format("YYYY-MM-DD");
    data.dropDate = moment(dropDate).format("YYYY-MM-DD");

    data.agentId =
      dumpType === "null" ? null : dumpType !== "" ? dumpType : null;

    Axios.post(MOBILE_URL + API_VERSION + "/dumpster/dumpsterrequest", data)
      .then((response) => {
        try {
          const { _id, fName } = response.data.data;
          console.log(response, "suuuuuu");
          if (fName) {
            this.setState({
              alertVisible: true,
              alertClass: "success",
              alertMessage: "Order placed successfully. ",
            });

           
            this.resetForm();
            this.props.history.push(`/payment/${_id}`);

            // window.parent.postMessage(
            //   {
            //     status: "200",
            //     msg: "change",
            //     url: window.location.origin + `/#/payment/${_id}`,
            //   },
            //   "*"
            // );
            
          } else {
            this.setState({
              alertVisible: true,
              alertClass: "danger",
              alertMessage: response.data.message,
            });
          }
        } catch (error) {
          console.log(error, 5555);
          toast.error("Server error");
        }
      })
      .catch((error) => {
        let res = error.response;
        let message = "please try after some time, server error ";

        if (res.data.message) {
          message = res.data.message;
        }

        this.setState({
          alertVisible: true,
          alertClass: "danger",
          alertMessage: message,
        });
      });
  };

  checkZipcode = (e) => {
    e.preventDefault();
    const { zipCode } = this.state;
    Axios.post(CHECK_ZIPCODE, { zipcode: zipCode })
      .then(async (res) => {
        if (res.status === 200) {
          let data = res.data.data;
          if (data.length > 0) {
            const county = [];
            county["city"] = [];
            await data.map((l) => {
              if (l.cityOrCountry === "city") {
                county["city"].push({ id: l._id, muni: l.muniName });
              } else {
                if (county[`${l.countyName.countyName}`] === undefined) {
                  county[`${l.countyName.countyName}`] = [];
                  county[`${l.countyName.countyName}`].push({
                    id: l._id,
                    muni: l.muniName,
                  });
                } else {
                  county[`${l.countyName.countyName}`].push({
                    id: l._id,
                    muni: l.muniName,
                  });
                }
              }
            });

            this.setState({
              citylist: county,
              pincode: zipCode,
            });
            // toast.success("please select Muni service");
            this.setState({
              alertVisible: true,
              alertClass: "success",
              alertMessage:
                "Yes, we service your zip code,Complete this form for instant guaranteed quote. ",
            });
          } else {
            this.setState({
              citylist: [],
            });
            this.setState({
              alertVisible: true,
              alertClass: "danger",
              alertMessage:
                "Currently, We do not service your zip code, Sorry. ",
            });
            // toast.error("No service at this Address");
          }
        }
      })
      .catch((err) => {
        toast.error("Server Error");
      });
  };

  resetForm = () => {
    this.setState({
      firstname: "",
      lastname: "",
      email: "",
      dumpsterSizeService: "",
      materialType: "",
      phoneNumber: "",
      cityService: "",
      zipCode: "",
      dropDate: "",
      pickDate: "",
      dropOn: "",
      dumpsterDuration: "",
      dropAccess: "",
      bestContact: "",
      hearAboutUs: "",
      companyInfo: "",
      anyOtherInfo: "",
      startLocationAddr: "",
    });
  };
  hideAlert = (e) => {
    // e.preventDefault();
    this.setState({
      alertVisible: false,
      alertClass: "success",
      alertMessage: "",
    });
  };
  render() {
    const {
      citylist,
      dumpsize,
      matrialSizes,
      bestContactList,
      dumpsterDurationList,
      type,
      city,
      county,
      dropOnList,
      dropaccess,
      firstname,
      lastname,
      email,
      dumpsterSizeService,
      materialType,
      phoneNumber,
      phoneNumber2,
      cityService,
      companyTitle,
      dropTime,
      pickTime,
      zipCode,
      dropDate,
      pickDate,
      dropOn,
      dumpsterDuration,
      bestContact,
      hearAboutUs,
      companyInfo,
      anyOtherInfo,
      startLocationAddr,
      endLocationAddr,
      startLocation,
      endLocation,
      status,
      alertClass,
      alertMessage,
      alertVisible,
      agentsList,
      dumpType,
    } = this.state;
    const data = this.props.data;

    let selectOptions = [];
    for (var prop in citylist) {
      let options = [];
      if (citylist[prop] && citylist[prop].length > 0) {
        citylist[prop].map((l) => {
          options.push(<option value={l.id}>{l.muni}</option>);
        });
      }
      selectOptions.push(<optgroup label={prop}>{options}</optgroup>);
    }

    return (
      <Fragment>
        {data.orderTopBannerImage && (
          <a href="tel:8886010677">
            <Image src={data.orderTopBannerImage} style={{ width: "100%" }} />
          </a>
        )}

        <section className="order-form oderform-col">
          <Container fluid>
            <Row>
              <Col md={12} lg={8}>
                <h3>INSTANT GUARANTEED QUOTE FORM</h3>
                <Form onSubmit={(e) => this.submitDumpster(e)} method="post">
                  <Row className="chekZipcode">
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        Zip Service Required{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        placeholder="Zipcode"
                        required
                        value={zipCode}
                        name={"zipCode"}
                        onChange={this.handleChange}
                        className="position-relative"
                      />

                      <Button
                        variant="warning"
                        className="order-btn-zip check"
                        type="button"
                        onClick={(e) => this.checkZipcode(e)}
                      >
                        Submit
                      </Button>
                    </Col>

                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        City Service Required
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>

                      <Form.Control
                        size="lg"
                        as="select"
                        required
                        value={cityService}
                        name={"cityService"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {selectOptions}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        Services Estimate Menu{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        required
                        value={dumpsterSizeService}
                        name={"dumpsterSizeService"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {dumpsize &&
                          dumpsize.map((d) => {
                            return <option value={d._id}>{d.name}</option>;
                          })}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                  </Row>
                  {alertVisible && (
                    <Row>
                      <Col>
                        <Alert
                          variant={alertClass}
                          onClose={(e) => this.hideAlert(e)}
                          dismissible
                        >
                          <p>{alertMessage}</p>
                        </Alert>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        Material Type{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        required
                        value={materialType}
                        name={"materialType"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {matrialSizes &&
                          matrialSizes.map((d) => {
                            return <option value={d._id}>{d.name}</option>;
                          })}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        Drop Space{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        required
                        value={dropOn}
                        name={"dropOn"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {dropon.length > 0 &&
                          dropon.map((keys, index) => {
                            for (let [key, value] of Object.entries(keys)) {
                              return (
                                <option value={key} key={key}>
                                  {value}
                                </option>
                              );
                            }
                          })}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        Drop Access
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        required
                        value={dropaccess}
                        name={"dropaccess"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {dropAccess.length > 0 &&
                          dropAccess.map((keys, index) => {
                            for (let [key, value] of Object.entries(keys)) {
                              return (
                                <option value={key} key={key}>
                                  {value}
                                </option>
                              );
                            }
                          })}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6} md={3} sm={3}>
                      <Form.Label>
                        Drop Off Date{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>

                      <DatePicker
                        selected={dropDate}
                        className="form-control form-control-lg"
                        name={"dropDate"}
                        onSelect={(e) => this.handleDate(e, "dropDate")}
                        onKeyDown={(e) => e.preventDefault()}
                        autoComplete="new-password"
                      />
                    </Col>

                    <Col xs={6} md={3} sm={3}>
                      <Form.Label>
                        Drop Off Time{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        required
                        value={dropTime}
                        name={"dropTime"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        <option value="Morning Delivery 6AM -12PM">
                          Morning Delivery 6AM -12PM
                        </option>
                        <option value="Afternoon 12PM - 6PM">
                          Afternoon 12PM - 6PM
                        </option>
                        <option value="Anytime">Anytime</option>
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>

                    <Col xs={6} md={3} sm={3}>
                      <Form.Label>
                        Pick Up Date{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>

                      <DatePicker
                        selected={pickDate}
                        className="form-control form-control-lg"
                        name={"pickDate"}
                        onSelect={(e) => this.handleDate(e, "pickDate")}
                        onKeyDown={(e) => e.preventDefault()}
                        autoComplete="new-password"
                      />
                    </Col>
                    <Col xs={6} md={3} sm={3}>
                      <Form.Label>
                        Pick Up Time{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        required
                        value={pickTime}
                        name={"pickTime"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        <option value="Morning Delivery 6AM -12PM">
                          Morning Delivery 6AM -12PM
                        </option>
                        <option value="Afternoon 12PM - 6PM">
                          Afternoon 12PM - 6PM
                        </option>
                        <option value="Anytime">Anytime</option>
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        Address Service Required
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        required
                        value={startLocationAddr}
                        name={"startLocationAddr"}
                        onChange={this.handleChange}
                      />
                    </Col>
                    <Col xs={6} md={4} sm={4}>
                      <Form.Label>
                        First Name{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        required
                        value={firstname}
                        name={"firstname"}
                        onChange={this.handleChange}
                      />
                    </Col>
                    <Col xs={6} md={4} sm={4}>
                      <Form.Label>
                        Last Name{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        required
                        value={lastname}
                        name={"lastname"}
                        onChange={this.handleChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>
                        Email{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        type="email"
                        required
                        value={email}
                        name={"email"}
                        onChange={this.handleChange}
                      />
                    </Col>
                    <Col xs={6} md={4} sm={4}>
                      <Form.Label>
                        Cell Phone{" "}
                        <span className="required">
                          <i class="fa fa-star" aria-hidden="true"></i>
                        </span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        required
                        value={phoneNumber}
                        name={"phoneNumber"}
                        onChange={this.handleChange}
                      />
                    </Col>
                    <Col xs={6} md={4} sm={4}>
                      <Form.Label>Other Phone</Form.Label>
                      <Form.Control
                        size="lg"
                        value={phoneNumber2}
                        name={"phoneNumber2"}
                        onChange={this.handleChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6} md={6} sm={6}>
                      <Form.Label>Company if Applicable</Form.Label>
                      <Form.Control
                        size="lg"
                        value={companyInfo}
                        name={"companyInfo"}
                        onChange={this.handleChange}
                      />
                    </Col>
                    <Col xs={6} md={6} sm={6}>
                      <Form.Label>Title if Applicable</Form.Label>
                      <Form.Control
                        size="lg"
                        value={companyTitle}
                        name={"companyTitle"}
                        onChange={this.handleChange}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={4} sm={4}>
                      <Form.Label>Submitted By</Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        value={dumpType}
                        name={"dumpType"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        <option value="null">Customer</option>
                        {agentsList.length > 0 &&
                          agentsList.map((keys, index) => {
                            return (
                              <option value={keys._id}>{keys.name}</option>
                            );
                          })}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                    <Col xs={6} md={4} sm={4}>
                      <Form.Label>Best Way to Contact You</Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        value={bestContact}
                        name={"bestContact"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {bestWay.length > 0 &&
                          bestWay.map((keys, index) => {
                            for (let [key, value] of Object.entries(keys)) {
                              return <option value={key}>{value}</option>;
                            }
                          })}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                    <Col xs={6} md={4} sm={4}>
                      <Form.Label>How did you hear of Us?</Form.Label>
                      <Form.Control
                        size="lg"
                        as="select"
                        value={hearAboutUs}
                        name={"hearAboutUs"}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {hearUs.length > 0 &&
                          hearUs.map((keys, index) => {
                            for (let [key, value] of Object.entries(keys)) {
                              return <option value={key}>{value}</option>;
                            }
                          })}
                      </Form.Control>
                      <div className="caret">
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Other info & Request</Form.Label>
                      <Form.Control
                        size="lg"
                        type="type"
                        value={anyOtherInfo}
                        name={"anyOtherInfo"}
                        onChange={this.handleChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        variant="warning"
                        className="order-btn"
                        size="lg"
                        type="submit"
                      >
                        <p className="bold-text">Submit</p>
                        <b>For Your Instant Guaranteed Price Quote</b>
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center style={{ color: "#fff" }}>
                        <b>
                          You May Immediately Schedule Your Order With a Credit
                          Card Payment From The Instant Quote Or You May
                          Schedule Your Order With a Credit Card Payment From
                          The Quote We Will Email You Automatically
                        </b>
                      </center>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        href="tel:8886010677"
                        variant="warning"
                        className="order-btn"
                        size="lg"
                        style={{
                          color: "#000",
                          fontWeight: 900,
                          padding: 5,
                        }}
                      >
                        Or Click To Call 888-601-0677
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col md={12} lg={4}>
                {/* <Image src={require("../../assets/img/logo.png")} /> */}
                {data.orderRightBannerImage && (
                  <Image src={data.orderRightBannerImage} />
                )}
              </Col>
            </Row>
            <ToastContainer position="top-left" />
          </Container>
        </section>
      </Fragment>
    );
  }
}

export default withRouter(OrderSubmit);
